import type {ReviewsType} from "../model/types";
import {Button} from "@/shared/ui/Button";
import styles from "./ProductReviews.module.scss";

type Props = {
    type: ReviewsType;
    totalCount: number;
    withImagesCount: number;
    onClick: (type: ReviewsType) => void;
};

export const ProductReviewsFilters = (
    {
        type,
        totalCount,
        withImagesCount,
        onClick
    }: Props
) => {

    if (withImagesCount === 0) {
        return null;
    }

    return (
        <div className={styles.buttons}>
            <Button
                variant={`tertiary`}
                className={styles.button}
                active={type === 'all'}
                onClick={() => onClick('all')}
            >
                Все отзывы ({totalCount})
                {/*Все отзывы*/}
            </Button>
            <Button
                variant={`tertiary`}
                className={styles.button}
                active={type === 'withImages'}
                onClick={() => onClick('withImages')}
            >
                Отзывы с фото ({withImagesCount})
                {/*Отзывы с фото*/}
            </Button>
        </div>
    );
}
